import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent as Close } from '../../assets/icons/close.svg';
import classes from '../../styles/components/modals/uploadModal.module.scss';

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
const AUDIO_EXTENSIONS = ['mp3', 'mpeg', 'wav', 'ogg', 'webm', 'm4a', 'mp4', 'aac'];

const FilePreviewModal = ({ file, onClose }) => {
    const [objectUrl, setObjectUrl] = useState(null);

    useEffect(() => {
        if (!file) return;
        const url = URL.createObjectURL(file);
        setObjectUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [file]);

    if (!file) return null;

    const ext = file.name.split('.').pop()?.toLowerCase();
    const isImage = IMAGE_EXTENSIONS.includes(ext);
    const isPdf = ext === 'pdf';
    const isAudio = AUDIO_EXTENSIONS.includes(ext) || (file.type && file.type.startsWith('audio/'));

    return (
        <>
            {ReactDOM.createPortal(
                <div className={classes.modalBackDrop} onClick={onClose} />,
                document.getElementById('backdrop-root')
            )}
            {ReactDOM.createPortal(
                <div
                    className={classes.answerModal}
                    onClick={(e) => e.stopPropagation()}
                    style={{ maxWidth: '90vw', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                        <span style={{ fontSize: 13, color: '#464646' }}>{file.name}</span>
                        <button
                            type="button"
                            onClick={onClose}
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: 4,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                            title="بستن"
                        >
                            <Close width={24} height={24} style={{ color: '#888' }} />
                        </button>
                    </div>
                    <div style={{ flex: 1, overflow: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', minHeight: 300 }}>
                        {objectUrl && isImage && (
                            <img src={objectUrl} alt={file.name} style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }} />
                        )}
                        {objectUrl && isPdf && (
                            <iframe
                                src={objectUrl}
                                title={file.name}
                                style={{ width: '100%', minHeight: 500, border: 'none' }}
                            />
                        )}
                        {objectUrl && isAudio && (
                            <audio controls src={objectUrl} style={{ width: '100%' }}>
                                مرورگر شما از پخش صدا پشتیبانی نمی‌کند.
                            </audio>
                        )}
                        {objectUrl && !isImage && !isPdf && !isAudio && (
                            <p style={{ color: '#888', padding: 20 }}>پیش‌نمایش برای این فرمت پشتیبانی نمی‌شود.</p>
                        )}
                    </div>
                </div>,
                document.getElementById('overlayUploadModal-root')
            )}
        </>
    );
};

export default FilePreviewModal;
